import investmentsAllianz from './investments-allianz.json';
import almostReady from './almost-ready.json';

export default {
  investments: {
    ...investmentsAllianz,
    ...almostReady,
  },
};
